export const minMonthlyPrice = 250;
export const maxMonthlyPrice = 10000;
